<nz-alert
    *ngIf="visible"
    nzType="warning"
    [nzDescription]="dataText"
    nzShowIcon
></nz-alert>
